<template>
  <el-footer height="30px">
    <div class="container">Copyright © 2015-2025 LaClub积分商城 All Rights Reserved</div>
  </el-footer>
</template>

<script>
export default {
  name: 'GlobalFooter',
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.el-footer
  background-color #FFFFFF
  .container
    flex-row-nowrap()
    justify-content center
    width 100%
    height 100%
    color #666666
</style>
